const goldpay = () => import ('@/pages/circulation/goldpay')
const borrow = () => import ('@/pages/circulation/borrow')
const goldcheck = () => import ('@/pages/circulation/goldcheck')
const financingDetail = () => import ('@/components/financing-page/financing-detail-page')
const financingDetailGold = () => import ('@/components/financing-page/gold-detail')
const contractDetail = () => import ('@/components/financing-page/contract-detail')
const borrowMain = () => import ('@/pages/circulation/gold-financing/gold-financing-steps/index')
export default [
    {
        path: 'circulation/goldpay',
        name:'circulation/goldpay',
        component: goldpay
    },
    {
        path: 'circulation/borrow',
        name:'circulation/borrow',
        component: borrow
    },
    {
        path: 'circulation/goldcheck',
        name:'circulation/goldcheck',
        component: goldcheck
    },
    {
        path: 'circulation/borrow/details/:id',
        name:'circulation/borrow/details/:id',
        component: financingDetail
    },
    {
      path: 'circulation/borrow/gold',
      name:'circulation/borrow/gold',
      component: financingDetailGold
    },
    {
        path: 'circulation/borrow/details/contract',
        name:'contractDetail',
        component: contractDetail
    },
    {
        path:'circulation/borrow/main',
        name:'circulation/borrow/main',
        component: borrowMain
    }
]



// WEBPACK FOOTER //
// ./src/router/circulation.js